/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowDownCircle = createReactComponent(
  "arrow-down-circle",
  "IconArrowDownCircle",
  [
    ["path", { d: "M12 7v14", key: "svg-0" }],
    ["path", { d: "M9 18l3 3l3 -3", key: "svg-1" }],
    ["path", { d: "M12 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4", key: "svg-2" }]
  ]
);

export { IconArrowDownCircle as default };
//# sourceMappingURL=IconArrowDownCircle.js.map
